import PersonaOfficeShell from "@/components/PersonaOfficeShell";
import {
  Users, UserCheck, Video, Globe, IdCard, Clapperboard, Search,
} from "lucide-react";

/** L11 · Casting Agency dashboard.
 *  Per-project fee model; sponsors talent/model verifications. */
const CONFIG = {
  layer:            "L11",
  label:            "Casting Agency",
  testidPrefix:     "casting-office",
  accent:           "#A78BFA",
  Icon:             Users,
  expectedOrgType:  "casting_agency",
  blurb:            "Match talent to briefs. Every callback, every side, every audition tape — organised.",
  showSponsorQueue: true,
  sponsorLabel:     "Talent & Model Verifications",
  tiles: [
    {
      key: "auditions", to: "/auditions", TileIcon: Video,
      title: "Auditions Vault",
      desc:  "Headless upload · masked player · slate the tapes to producers when a brief drops.",
      chip: "Live", chipTone: "live",
    },
    {
      key: "directory", to: "/directory?kind=talent_model", TileIcon: Search,
      title: "Talent Directory",
      desc:  "Search every verified talent + model on Call·Sheet. Filter by tier, city, section.",
      chip: "Live", chipTone: "live",
    },
    {
      key: "briefs", to: "/office/desks/brief", TileIcon: Clapperboard,
      title: "Casting Briefs",
      desc:  "Track incoming casting briefs from producers — role · date · rate · deadline.",
      chip: "Beta", chipTone: "beta",
    },
    {
      key: "pending", to: "/pending-individuals", TileIcon: UserCheck,
      title: "Pending Talent",
      desc:  "Approve talent who chose your agency as their verification sponsor.",
      chip: "Live", chipTone: "live",
    },
    {
      key: "public-profile", to: "/office/public-profile", TileIcon: Globe,
      title: "Public Profile",
      desc:  "Your @handle — hero, showreel, roster grid, credits — the producer-facing view.",
      chip: "Live", chipTone: "live",
    },
    {
      key: "icard", to: "/icard", TileIcon: IdCard,
      title: "Owner iCard",
      desc:  "Your verified, co-branded identity card. Screen it at meetings.",
      chip: "Live", chipTone: "live",
    },
  ],
};

export default function CastingAgencyDashboard() {
  return <PersonaOfficeShell config={CONFIG} />;
}
